import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/careers`;

export const pathwaysLinks = {
  root: () => base,
  search: (term?: string) => ({ pathname: `${base}/search`, state: { term } }),
  topMatchesList: () => `${base}/topMatches`,
  inDemand: () => `${base}/inDemand`,
  showCategory: (id: number) => `${base}/categories/${id}`,
  categoryJobs: (id: number) => `${base}/categoryJobs/${id}`,
  showOccupation: (id: number) => `${base}/occupations/${id}`,
};

export default pathwaysLinks;
